import Vue from 'vue'
import Bugsnag from '@bugsnag/js'
import BugsnagPluginVue from '@bugsnag/plugin-vue'
import store from '@/store'

Bugsnag.start({
  apiKey: 'aee2c69d1916429fae100263caa85f1b',
  plugins: [new BugsnagPluginVue()],
  appVersion: APPVERSION,
  // eslint-disable-next-line consistent-return
  onError: event => {
    if (process.env.NODE_ENV === 'development') {
      return false
    }

    if (!event.getUser()?.id) {
      const user = store.getters['user/session']
      if (user) {
        Bugsnag.setUser(user.steamid, user.email, user.name)
        Bugsnag.addMetadata('user', user)
      }
    }
  },
})

Bugsnag.getPlugin('vue').installVueErrorHandler(Vue)

export default true
